import { useEffect, useState, useContext } from "react";
import ordersService from "services/orders.service";
import crudsService from "services/cruds-service";
import { AuthContext } from "context";

import Footer from "e4acomponents/Footer";
import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import ViewOrderProducts from "../components/view-order-products";

import { OrderCard } from "../components/orderCard";

export default function ViewOrders() {
    const [orders, setOrders] = useState([]);
    const [openOrderProducts, setOpenOrderProducts] = useState(null);
    const [orderProducts, setOrderProducts] = useState([]);
    const [orderNum, setOrderNum] = useState(null);

    const authContext = useContext(AuthContext);

    const handleCloseOrderProducts = () => setOpenOrderProducts(false);
    const handleViewOrderProducts = (order) => {
        setOrderProducts(order.products);
        setOrderNum(order.id);
        setOpenOrderProducts(true);
    };

    useEffect(() => {
        (async () => {
            // Fetch orders with products
            try {
                const userId = await authContext.getCurrentUser();
                const currentUser = await crudsService.getUser(userId);

                const org = currentUser.data.relationships.organizations;
                let response = {};
                if (org) {
                    response = await ordersService.getOrgOrders(org.data[0].id);
                } else {
                    response = await ordersService.getOrdersWithProducts();

                }

                const attrs = response?.data?.attributes ?? [];
                const mappedOrders = mapOrders(attrs);
                setOrders(mappedOrders);
            
            } catch (error) {
                console.error("Error fetching orders with products:", error);
            }
        })();
    }, [])

    const mapOrders = (attrs) =>
        attrs.map((o) => {
            // Build items from productNumbers if available; otherwise derive from products
            let items = [];
            const pnEntries = Object.entries(o.productNumbers || {});
            
            if (pnEntries.length) {
                items = pnEntries.map(([code, info]) => ({
                    product: (code.split("-")[0] || code).replace(/[^A-Z]/g, ""),
                    qty: info?.count ?? 0,
                }));
            } else {
                const counts = {};
                (o.products || []).forEach((p) => {
                    const prefix = (p.serialNumber || "").split("-")[0] || "UNKNOWN";
                    const key = prefix.replace(/[^A-Z]/g, "");
                    counts[key] = (counts[key] || 0) + 1;
                });
                items = Object.entries(counts).map(([product, qty]) => ({ product, qty }));
            }

            // Sum total price from products
            const totalPrice = (o.products || []).reduce(
                (sum, p) => sum + (Number(p?.price) || 0),
                0
            );

            return {
                id: o.order_num ?? o._id,
                description: o.desc ?? "",
                organization: o.organization?.name ?? "",
                numProducts: o.qty ?? (o.products?.length ?? 0),
                assignedOn: o.createdAt ? new Date(o.createdAt).toISOString().slice(0, 10) : "",
                items,
                totalPrice,
                products: o.products || [],
            };
        });

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <ViewOrderProducts
                open={openOrderProducts}
                handleClose={handleCloseOrderProducts}
                products={orderProducts}
                orderNum={orderNum}
            />
            <MDBox py={3} display="flex" justifyContent="space-between" flexDirection="column" minHeight="85vh">
                {/* <MDBox mb={3}>
                    <MDTypography variant="h5">View Orders</MDTypography>
                </MDBox> */}

                <Grid container justifyContent="center" spacing={3}>
                    {orders.map((order) => (
                        <Grid key={order.id} item xs={12} md={8}>
                            <OrderCard
                                order={order}
                                onViewProducts={() => handleViewOrderProducts(order)}
                            />
                        </Grid>
                    ))}
                </Grid>

                <MDBox mt={3}>
                    <Footer />
                </MDBox>
            </MDBox>
        </DashboardLayout>
    );
}
